import styled from '@emotion/styled/macro';
import { PopoverItem, Variables } from '@enter/core';
import { ChartCard } from './chart-card';

export const ClaimVolumeCard = styled(ChartCard)``;
export const OptionItem = styled(PopoverItem)`
    color: ${Variables.Colors.n100};
    font-weight: 500;
`;
export const Message = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    flex-grow: 1;
    text-align: center;

    font-size: 18px;
    font-weight: 500;
`;
export const CaptionRow = styled.div`
    display: flex;
    flex-direction: row;
`;
export const CaptionCol = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 24px;
`;
export const CaptionLabel = styled.div`
    font-size: 15px;
    color: ${Variables.Colors.n50};
`;
export const CaptionValue = styled.div`
    font-size: 26px;
    font-weight: 300;
    letter-spacing: 1px;
    color: ${Variables.Colors.n100};
`;
